document.addEventListener('DOMContentLoaded', (evt) => {
    // these scripts will be excluded from WP rocket
});
